import { useState } from 'react';
import { getAllAgg } from '../../data/data';
import { usePoll } from '../../data/fetch/useFetch';
import { parseMatchData } from '../../data/parseMatchData';
import { getConfiguration } from '../../data/utils';
import Loader from '../../common/Loader';

export default function EventFetcher(props) {
    const conf = getConfiguration();
    const match = props.data;
    const [aggId, setAggId] = useState(getAllAgg(true, match.sportRef).idAggregata);
    const changeAgg = (aggId) => setAggId(aggId);

    const [isLoading, isError, data] = usePoll(conf.api.getEvento, {
            pal: match.pal,
            avv: match.avv,
            idAggregata: aggId,
            isLive: true
        },
        (data) => {
            return parseMatchData(data, aggId, match, true, true);
        }
    );

    
    if (isLoading || isError) {
        if (props.renderTempItem) {
            return props.renderTempItem(isLoading, isError);
        } else {
            return <Loader error={isError} />;
        }
    }

    return props.renderItem(data, aggId, changeAgg);
}
